import PropTypes from "prop-types";
import Default from "./default";
import Reviews from "./reviews";

const Template = [
	{
		id: "default",
		component: Default,
	},
	{
		id: "reviews",
		component: Reviews,
	},
];

const Desktop = ({
	type, ...otherProps
}) => (
	Template.filter((item) => item.id === type).map((style, idx) => (
		<style.component
			key={`${type}-${String(idx)}`}
			{...otherProps}
		/>
	))
);

Desktop.propTypes = {
	type: PropTypes.string,
};

Desktop.defaultProps = {
	type: "default",
};

export default Desktop;
